const $slider = $('.js-slider');

if ($slider.length) {
    initSliders($slider);
}

export function initSliders($sliders) {
    $sliders.each(function(i) {
        const $g = $(this);
        const $container = $g.closest('.js-slider-wrap');
        const $textPagination = $container.find('.js-slider-text-pagination');
        const slidesCount = $container.find('.slide').length;
        const $prevBtn = $container.find('.js-slider-prev');
        const $nextBtn = $container.find('.js-slider-next');
        const hasCursor = $g.closest('.text').length && !$g.closest('.page-news-wrapper__main-news').length;

        if ($g.find('.slide').length === 1) {
            const $slideImg = $g.find('.slide').find('img');

            $slideImg.addClass('swiper-lazy-loaded').attr('src', $slideImg.data('src'));
            $slideImg.siblings('.swiper-lazy-preloader').hide();

            return false;
        }

        // Возможность делать множественные галереи
        $g.addClass(`js-slider-${i}`);
        $container.find('.js-slider-pagination').addClass(`js-slider-pagination-${i}`);
        $textPagination.html(`1/${slidesCount}`);
        if (hasCursor && !App.mobile) {
            $g.append(`
                <div class="swiper-cursor-pointer js-swiper-cursor-pointer">
                    <svg width="42" height="14" viewBox="0 0 42 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M34.636 13.7782L33.2218 12.364L37.8076 7.77817L0 7.77816L1.74846e-07 5.77816L37.5856 5.77817L33.2217 1.41421L34.6359 0L41.5254 6.8895L34.636 13.7782Z" fill="#FFFFFF"/></svg>
                    <div class="swiper-cursor-prev"></div>
                    <div class="swiper-cursor-next"></div>
                </div>
            `);
            initCursor($g[0]);
        }

        // Инициализация
        const swiper = new Swiper(`.js-slider-${i}`, {
            //loop: true,
            loop: !$g.is('[data-no-loop]'),
            slidesPerView: 'auto',
            spaceBetween: 8,
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 3
            },
            pagination: {
                el: `.js-slider-pagination-${i}`,
                clickable: true
            },
            threshold: 10,
            roundLengths: true,
            speed: 300,
            a11y: true,
            breakpoints: {
                768: {
                    spaceBetween: 20
                }
            },
            navigation: {
                nextEl: '.swiper-cursor-next',
                prevEl: '.swiper-cursor-prev',
            }
        });

        swiper.on('slideChange', function () {
            $textPagination.html(`${swiper.realIndex + 1}/${slidesCount}`);
        });

        if ($prevBtn.length) {
            $prevBtn.on('click', function () {
                swiper.slidePrev();
            });
        }

        if ($nextBtn.length) {
            $nextBtn.on('click', function () {
                swiper.slideNext();
            });
        }
    });
}

// курсор с стрелкой
function initCursor(swiperDom) {
    const cursor = swiperDom.querySelector('.js-swiper-cursor-pointer');
    const svg = cursor.querySelector('svg');
    let isPrevCache = true;
    let swiperPosition = getCoords(swiperDom);
    let cursorX = 0;
    let cursorY = 0;
    let mouseX = 0;
    let mouseY = 0;
    let isInside = false;
    let speed = 0.5;
    let padding = 0.25;

    App.W.on('resized', () => {
        swiperPosition = getCoords(swiperDom);
    });

    $(swiperDom).addClass('_swiper-cursor');

    swiperDom.addEventListener('mousemove', (e) => {
        mouseX = e.pageX;
        mouseY = e.pageY;

        const isPrev = mouseX < 325 + swiperPosition.left;

        if (isPrevCache != isPrev) {
            isPrevCache = isPrev;
            $(cursor).toggleClass('_left', isPrev);
        }

        if (mouseY - window.pageYOffset > swiperDom.getBoundingClientRect().top + swiperPosition.box.height - 40) {
            $(swiperDom).removeClass('_show-cursor');
        } else {
            $(swiperDom).addClass('_show-cursor');
        }
    });
    swiperDom.addEventListener('mouseenter', () => {
        isInside = true;
        animate();
        $(swiperDom).addClass('_show-cursor');
    });
    swiperDom.addEventListener('mouseleave', () => {
        isInside = false;
        $(swiperDom).removeClass('_show-cursor');
    });

    animate();

    function animate() {
        let distX = mouseX - cursorX - swiperPosition.left;
        let distY = mouseY - cursorY - swiperPosition.top;
        const halfWidth = swiperPosition.box.width / 2;
        const halfHeight = swiperPosition.box.height / 2;

        cursorX = cursorX + (distX * speed);
        cursorY = cursorY + (distY * speed);

        let paddingX = (1 - cursorX / halfWidth) * padding * 100;
        let paddingY = (1 - cursorY / halfHeight) * padding * 100;

        cursor.style.left = cursorX + 'px';
        cursor.style.top = cursorY + 'px';
        svg.style.left = paddingX + 'px';
        svg.style.top = paddingY + 'px';

        if (isInside) requestAnimationFrame(animate);
    }
}

function getCoords(elem) {
    let box = elem.getBoundingClientRect();

    return {
        box: box,
        top: box.top + window.pageYOffset,
        right: box.right + window.pageXOffset,
        bottom: box.bottom + window.pageYOffset,
        left: box.left + window.pageXOffset
    };
}



// WEBPACK FOOTER //
// ./_src/js/Slider.js